import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guide",
  "use": "icon-guide-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-guide\"><path d=\"m11.89 560.842 289.526 129.392 559.25-523.687L369.808 731.09l371.344 149.825c8.948 3.4 19.169-1.36 22.367-10.9v-.68L1023.647.377 10.61 526.798c-8.957 4.775-12.147 15.667-8.317 25.2 2.56 4.086 5.758 7.492 9.597 8.852zm357.277 462.398L513.61 857.765l-144.443-62.65v228.133z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol